// @ts-nocheck
import saveCartReducer, {
    StoreSaveCartActions,
} from "@store/Framework/Store/Store/Components/SaveCart/SaveCartReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    saveCart: saveCartReducer,
};

export type StoreComponentsActions = StoreSaveCartActions;
export default combineReducers(componentsReducers);
